/* SFS circular gallery: curved WebGL carousel (OGL). Falls back to the HTML tile grid if WebGL, the library or an image fails. */
(function () {

  function lerp(a, b, t) { return a + (b - a) * t; }
  function debounce(fn, wait) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, wait); }; }

  function textTexture(O, gl, text, font, color) {
    var c = document.createElement('canvas'), x = c.getContext('2d');
    x.font = font;
    var w = Math.ceil(x.measureText(text).width), h = Math.ceil(parseInt((font.match(/(\d+)px/) || [0, 30])[1], 10) * 1.3);
    c.width = w + 24; c.height = h + 24;
    x.font = font; x.fillStyle = color; x.textBaseline = 'middle'; x.textAlign = 'center';
    x.fillText(text, c.width / 2, c.height / 2);
    var tex = new O.Texture(gl, { generateMipmaps: false });
    tex.image = c;
    return { texture: tex, width: c.width, height: c.height };
  }

  function init(root, O) {
    var items = [];
    root.querySelectorAll('[data-cg-item]').forEach(function (a) {
      items.push({ image: a.getAttribute('data-img'), text: a.getAttribute('data-title'), href: a.getAttribute('href') });
    });
    if (!items.length) return;
    var stage = root.querySelector('.sfsx-cg__stage');
    root.classList.add('is-gl');
    var bendBase = parseFloat(root.getAttribute('data-bend') || '3');
    var radius = parseFloat(root.getAttribute('data-radius') || '0.06');
    var ease = 0.06, speedMul = 2;
    var textColor = root.getAttribute('data-text-color') || '#111111';
    var font = "italic 600 34px 'Playfair Display', Georgia, serif";

    var renderer = new O.Renderer({ alpha: true, antialias: true, dpr: Math.min(window.devicePixelRatio || 1, 2) });
    var gl = renderer.gl;
    gl.clearColor(0, 0, 0, 0);
    gl.canvas.setAttribute('aria-hidden', 'true');
    stage.appendChild(gl.canvas);

    var camera = new O.Camera(gl);
    camera.fov = 45; camera.position.z = 20;
    var scene = new O.Transform();
    var geometry = new O.Plane(gl, { heightSegments: 50, widthSegments: 100 });
    var screen = { width: 1, height: 1 }, viewport = { width: 1, height: 1 };
    var scroll = { current: 0, target: 0, last: 0, position: 0 };
    var medias = [];
    var failed = false;

    var vertex = 'precision highp float;attribute vec3 position;attribute vec2 uv;uniform mat4 modelViewMatrix;uniform mat4 projectionMatrix;uniform float uTime;uniform float uSpeed;varying vec2 vUv;void main(){vUv=uv;vec3 p=position;p.z=(sin(p.x*4.0+uTime)*1.5+cos(p.y*2.0+uTime)*1.5)*(0.1+uSpeed*0.5);gl_Position=projectionMatrix*modelViewMatrix*vec4(p,1.0);}';
    var fragment = 'precision highp float;uniform vec2 uImageSizes;uniform vec2 uPlaneSizes;uniform sampler2D tMap;uniform float uBorderRadius;varying vec2 vUv;float rb(vec2 p,vec2 b,float r){vec2 d=abs(p)-b;return length(max(d,vec2(0.0)))+min(max(d.x,d.y),0.0)-r;}void main(){vec2 ratio=vec2(min((uPlaneSizes.x/uPlaneSizes.y)/(uImageSizes.x/uImageSizes.y),1.0),min((uPlaneSizes.y/uPlaneSizes.x)/(uImageSizes.y/uImageSizes.x),1.0));vec2 uv=vec2(vUv.x*ratio.x+(1.0-ratio.x)*0.5,vUv.y*ratio.y+(1.0-ratio.y)*0.5);vec4 color=texture2D(tMap,uv);float d=rb(vUv-0.5,vec2(0.5-uBorderRadius),uBorderRadius);float a=1.0-smoothstep(-0.002,0.002,d);gl_FragColor=vec4(color.rgb,a);}';
    var titleVertex = 'attribute vec3 position;attribute vec2 uv;uniform mat4 modelViewMatrix;uniform mat4 projectionMatrix;varying vec2 vUv;void main(){vUv=uv;gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0);}';
    var titleFragment = 'precision highp float;uniform sampler2D tMap;varying vec2 vUv;void main(){vec4 c=texture2D(tMap,vUv);if(c.a<0.1)discard;gl_FragColor=c;}';

    function Media(item, index, length) {
      this.item = item; this.index = index; this.length = length; this.extra = 0;
      var tex = new O.Texture(gl, { generateMipmaps: true });
      this.program = new O.Program(gl, {
        depthTest: false, depthWrite: false, vertex: vertex, fragment: fragment,
        uniforms: { tMap: { value: tex }, uPlaneSizes: { value: [0, 0] }, uImageSizes: { value: [0, 0] }, uSpeed: { value: 0 }, uTime: { value: 100 * Math.random() }, uBorderRadius: { value: radius } },
        transparent: true
      });
      var img = new Image(), self = this;
      img.crossOrigin = 'anonymous';
      img.onload = function () { tex.image = img; self.program.uniforms.uImageSizes.value = [img.naturalWidth, img.naturalHeight]; };
      img.onerror = function () { failed = true; fallback(); };
      img.src = item.image;
      this.plane = new O.Mesh(gl, { geometry: geometry, program: this.program });
      this.plane.setParent(scene);
      var t = textTexture(O, gl, item.text, font, textColor);
      var tp = new O.Program(gl, { vertex: titleVertex, fragment: titleFragment, uniforms: { tMap: { value: t.texture } }, transparent: true });
      this.title = new O.Mesh(gl, { geometry: new O.Plane(gl), program: tp });
      this.titleAspect = t.width / t.height;
      this.title.setParent(this.plane);
      this.resize();
    }
    Media.prototype.resize = function () {
      var s = screen.height / 1500;
      var small = screen.width < 620;
      this.plane.scale.y = (viewport.height * (900 * s)) / screen.height * (small ? 1.05 : 1);
      this.plane.scale.x = (viewport.width * (700 * s)) / screen.width * (small ? 1.05 : 1);
      this.plane.scale.x = this.plane.scale.y; /* square photos */
      this.program.uniforms.uPlaneSizes.value = [this.plane.scale.x, this.plane.scale.y];
      this.padding = small ? 1.2 : 2;
      this.width = this.plane.scale.x + this.padding;
      this.widthTotal = this.width * this.length;
      this.x = this.width * this.index;
      var th = 0.13; /* relative to plane (child scale) */
      this.title.scale.set(th * this.titleAspect / this.plane.scale.x * this.plane.scale.y, th, 1);
      this.title.position.y = -0.5 - th * 0.5 - 0.04;
    };
    Media.prototype.update = function (direction) {
      var x = this.x - scroll.current - this.extra;
      this.plane.position.x = x;
      var H = viewport.width / 2;
      var bend = bendBase * Math.min(1, Math.max(0.35, screen.width / 1000));
      if (bend === 0) { this.plane.position.y = 0; this.plane.rotation.z = 0; }
      else {
        var B = Math.abs(bend), R = (H * H + B * B) / (2 * B), ex = Math.min(Math.abs(x), H);
        var arc = R - Math.sqrt(R * R - ex * ex);
        if (bend > 0) { this.plane.position.y = -arc; this.plane.rotation.z = -Math.sign(x) * Math.asin(ex / R); }
        else { this.plane.position.y = arc; this.plane.rotation.z = Math.sign(x) * Math.asin(ex / R); }
      }
      this.program.uniforms.uTime.value += 0.04;
      this.program.uniforms.uSpeed.value = Math.min(Math.abs(scroll.current - scroll.last), 1.5);
      var po = this.plane.scale.x / 2, vo = viewport.width / 2;
      if (direction === 'right' && x + po < -vo) this.extra -= this.widthTotal;
      if (direction === 'left' && x - po > vo) this.extra += this.widthTotal;
    };

    function resize() {
      screen = { width: stage.clientWidth, height: stage.clientHeight };
      renderer.setSize(screen.width, screen.height);
      camera.perspective({ aspect: screen.width / screen.height });
      var fov = (camera.fov * Math.PI) / 180;
      var h = 2 * Math.tan(fov / 2) * camera.position.z;
      viewport = { width: h * camera.aspect, height: h };
      medias.forEach(function (m) { m.resize(); });
    }

    var all = items.concat(items);
    resize();
    all.forEach(function (it, i) { medias.push(new Media(it, i, all.length)); });

    /* caption + CTA for the centered item */
    var cap = root.querySelector('.sfsx-cg__cap-name'), btn = root.querySelector('.sfsx-cg__cap-btn');
    var lastIdx = -1;
    function centered() {
      var best = null, bd = 1e9;
      medias.forEach(function (m) { var d = Math.abs(m.plane.position.x); if (d < bd) { bd = d; best = m; } });
      return best;
    }
    function updateCap() {
      var m = centered(); if (!m) return;
      var i = m.index % items.length;
      if (i === lastIdx) return; lastIdx = i;
      if (cap) cap.textContent = m.item.text;
      if (btn) { btn.setAttribute('href', m.item.href); btn.textContent = 'Shop ' + m.item.text; }
    }

    function snap() {
      var w = medias[0].width, i = Math.round(Math.abs(scroll.target) / w), v = w * i;
      scroll.target = scroll.target < 0 ? -v : v;
    }
    var snapLater = debounce(snap, 180);
    function step(n) { scroll.target += medias[0].width * n; snap(); idle = 0; }

    /* drag / swipe */
    var down = false, startX = 0, moved = 0, startY = 0, axisLocked = null;
    function px(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
    function py(e) { return e.touches ? e.touches[0].clientY : e.clientY; }
    function onDown(e) { down = true; moved = 0; axisLocked = null; scroll.position = scroll.current; startX = px(e); startY = py(e); idle = 0; }
    function onMove(e) {
      if (!down) return;
      var dx = startX - px(e), dy = startY - py(e);
      if (axisLocked === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) axisLocked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (axisLocked !== 'x') return;
      if (e.cancelable) e.preventDefault();
      moved = Math.max(moved, Math.abs(dx));
      var k = viewport.width / screen.width * 1.1;
      scroll.target = scroll.position + dx * k;
    }
    function onUp(e) {
      if (!down) return; down = false;
      if (moved < 6 && axisLocked !== 'y') {
        var r = stage.getBoundingClientRect();
        var cx = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX);
        var wx = ((cx - r.left) / r.width - 0.5) * viewport.width;
        var hit = null;
        medias.forEach(function (m) { if (Math.abs(m.plane.position.x - wx) < m.plane.scale.x / 2) hit = m; });
        if (hit) { window.location.href = hit.item.href; return; }
      }
      snap();
    }
    stage.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    stage.addEventListener('touchstart', onDown, { passive: true });
    stage.addEventListener('touchmove', onMove, { passive: false });
    stage.addEventListener('touchend', onUp);
    /* horizontal trackpad scroll only, so page scrolling is never hijacked */
    stage.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      scroll.target += (e.deltaX > 0 ? speedMul : -speedMul) * 0.35;
      idle = 0; snapLater();
    }, { passive: false });
    root.querySelectorAll('[data-cg-step]').forEach(function (b) {
      b.addEventListener('click', function () { step(parseInt(b.getAttribute('data-cg-step'), 10)); });
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); }
      if (e.key === 'Enter') { var m = centered(); if (m) window.location.href = m.item.href; }
    });

    /* gentle auto-advance, paused on hover, touch, focus or when off screen */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hovering = false, visible = true, idle = 0;
    root.addEventListener('mouseenter', function () { hovering = true; });
    root.addEventListener('mouseleave', function () { hovering = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(root);

    var raf, lastT = performance.now();
    function tick(t) {
      var dt = t - lastT; lastT = t;
      if (!reduce && !hovering && !down && visible) { idle += dt; if (idle > 3200) { step(1); idle = 0; } }
      scroll.current = lerp(scroll.current, scroll.target, ease);
      var dir = scroll.current > scroll.last ? 'right' : 'left';
      if (visible) {
        medias.forEach(function (m) { m.update(dir); });
        renderer.render({ scene: scene, camera: camera });
        updateCap();
      }
      scroll.last = scroll.current;
      raf = requestAnimationFrame(tick);
    }
    window.addEventListener('resize', debounce(resize, 120));

    function fallback() {
      cancelAnimationFrame(raf);
      root.classList.remove('is-gl');
      if (gl.canvas.parentNode) gl.canvas.parentNode.removeChild(gl.canvas);
    }
    raf = requestAnimationFrame(tick);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-sfsx-cg]');
    if (!roots.length) return;
    var probe = document.createElement('canvas');
    var ok = !!(probe.getContext('webgl') || probe.getContext('experimental-webgl'));
    if (!ok) return;
    /* OGL is loaded by a small <script type="module"> in the section (Shopify's asset minifier breaks dynamic import in theme JS). */
    var run = function (O) {
      var go = function () { roots.forEach(function (r) { if (!r.__cg) { r.__cg = 1; try { init(r, O); } catch (e) { r.classList.remove('is-gl'); } } }); };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go();
    };
    if (window.SFSX_OGL) run(window.SFSX_OGL);
    else window.addEventListener('sfsx:ogl', function () { if (window.SFSX_OGL) run(window.SFSX_OGL); }, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
